import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { publishMenu } from 'src/api/publishMenu/publishMenu';
import { IPublishMenuRequestBody, IPublishMenuResponseBody } from 'src/api/publishMenu/types';

type Options = Omit<
  UseMutationOptions<IPublishMenuResponseBody, unknown, IPublishMenuRequestBody, unknown>,
  'mutationFn'
>;

export const usePublishMenu = (menuId: string, options: Options = {}) => {
  return useMutation((payload: IPublishMenuRequestBody) => publishMenu(menuId, payload), options);
};
